module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timestamps",
    class: {
      'small-screen': _vm.isSmallScreen()
    }
  }, [_c('form', {
    staticClass: "convert",
    class: {
      'focus': _vm.newValueFocus
    },
    on: {
      "submit": _vm.handleAdd
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.newValueFocus),
      expression: "newValueFocus"
    }],
    staticClass: "new-value",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "spellcheck": "false",
      "id": "new-value",
      "placeholder": "Enter a timestamp, iso string, date, ...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "focus": function($event) {
        _vm.newValueFocus = true
      },
      "blur": function($event) {
        _vm.newValueFocus = false
      },
      "keydown": _vm.handleKeyDown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "datetime-picker-button"
  }, [_c('button', {
    staticClass: "date-picker",
    attrs: {
      "type": "button",
      "title": "Open a date/time picker"
    },
    on: {
      "click": _vm.handleDateTimePicker
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "convert",
    attrs: {
      "type": "submit",
      "title": "Convert the entered date/time"
    }
  }, [_vm._v("convert")])]), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]), _vm._v(" "), (_vm.showHelp || _vm.items.length === 0) ? _c('div', {
    staticClass: "intro",
    style: ({
      maxWidth: (_vm.contentsWidth + 'px')
    })
  }, [_c('div', {
    staticClass: "intro-contents"
  }, [_c('p', [_vm._v("Hi there! tttimestamps converts timestamps, ISO strings, dates, and more for you. Just enter any date-like input in the text field above and press enter. Entered inputs appear in an editable table displaying various time formats side by side.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Example inputs:\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("1291141800000")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("2017-01-14T20:09:50.912Z")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("08/25/2016")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("2014-11-30 18:30")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("2014-10-06 22:45:00 UTC")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("today")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("tomorrow 08:00")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("last Wednesday")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.insertExample
    }
  }, [_vm._v("yesterday 09:30 PM New York")])])]), _vm._v(" "), _c('p', [_vm._v("\n        Tip: check out the configuration page "), _c('button', {
    staticClass: "actions config",
    attrs: {
      "type": "button",
      "title": "Configure tttimestamps"
    },
    on: {
      "click": _vm.handleShowConfig
    }
  }), _vm._v(" to customize table columns and timezones.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.items.length !== 0) ? _c('input', {
    staticClass: "dismiss",
    attrs: {
      "type": "button",
      "value": "Got it!"
    },
    on: {
      "click": _vm.hideIntro
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "row head",
    style: ({
      visibility: (_vm.items.length > 0) ? 'visible' : 'hidden'
    })
  }, [_c('div', {
    staticClass: "col drag-handle-header"
  }), _vm._v(_vm._s()), (_vm.descriptions) ? _c('div', {
    staticClass: "col head",
    style: ({
      width: _vm.DESCRIPTIONS_WIDTH + 'px'
    })
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          description\n        ")])]) : _vm._e(), _vm._v(_vm._s()), _vm._l((_vm.columns), function(column) {
    return _c('div', {
      staticClass: "col head",
      style: ({
        width: column.definition.width + 'px'
      })
    }, [_c('div', {
      staticClass: "label"
    }, _vm._l((_vm.label(column).split('\n')), function(line) {
      return _c('div', {
        staticClass: "label-line"
      }, [_vm._v(_vm._s(line))])
    }))])
  }), _vm._v(_vm._s()), _c('div', {
    staticClass: "col action-header"
  }), _vm._v(_vm._s()), _c('div', {
    staticClass: "col action-header"
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "dragula",
      rawName: "v-dragula",
      value: (_vm.items),
      expression: "items"
    }],
    attrs: {
      "id": "drag-container",
      "service": "itemsService",
      "drake": "items"
    }
  }, _vm._l((_vm.limitedItems), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "row",
      class: {
        'focus': !!item.focus
      },
      on: {
        "keydown": function (event) { return _vm.handleTableKeyDown(event, index); }
      }
    }, [_vm._m(0, true), _vm._v(_vm._s()), (_vm.descriptions) ? _c('div', {
      staticClass: "col",
      style: ({
        width: _vm.DESCRIPTIONS_WIDTH + 'px'
      })
    }, [_c('div', {
      staticClass: "label cell"
    }, [_vm._v("description")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "autocorrect": "off",
        "autocapitalize": "off"
      },
      domProps: {
        "value": item.timestamp.description
      },
      on: {
        "input": function (event) { return _vm.update(index, item.timestamp.value, item.timestamp.type, item.timestamp.timezone, item.timestamp.period, event.target.value); },
        "focus": function (event) { return _vm.focus(index, 'description'); },
        "blur": function (event) { return _vm.blur(index, 'description'); }
      }
    })]) : _vm._e(), _vm._v(_vm._s()), _vm._l((_vm.columns), function(column) {
      return _c('div', {
        staticClass: "col",
        style: ({
          width: column.definition.width + 'px'
        })
      }, [_c('div', {
        staticClass: "label cell"
      }, [_vm._v(_vm._s(_vm.label(column)))]), _vm._v(" "), _c('input', {
        class: {
          invalid: item.timestamp.type === column.type && !item.timestamp.isValid
        },
        attrs: {
          "type": "text",
          "autocomplete": "off",
          "autocorrect": "off",
          "autocapitalize": "off",
          "spellcheck": "false",
          "readonly": column.definition.isReadonly,
          "placeholder": _vm.placeholder(column)
        },
        domProps: {
          "value": item.timestamp.format(column.type, column.timezone, column.period)
        },
        on: {
          "input": function (event) { return _vm.update(index, event.target.value, column.type, column.timezone, column.period, item.timestamp.description); },
          "focus": function (event) { return _vm.focus(index, column); },
          "blur": function (event) { return _vm.blur(index, column); }
        }
      }), _vm._v(" "), (column.type === 'dateTime' && _vm.day(item.timestamp, column.timezone)) ? _c('div', {
        staticClass: "day-tag",
        class: {
          'focus': item.focus === column
        },
        attrs: {
          "title": _vm.fullDay(item.timestamp, column.timezone)
        }
      }, [_vm._v("\n            " + _vm._s(_vm.day(item.timestamp, column.timezone)) + "\n          ")]) : _vm._e()])
    }), _vm._v(_vm._s()), _c('div', {
      staticClass: "col action duplicate",
      attrs: {
        "title": "Click to duplicate this row (Ctrl + D)"
      }
    }, [_c('input', {
      staticClass: "action duplicate",
      attrs: {
        "type": "button",
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.duplicate(index)
        },
        "focus": function (event) { return _vm.focus(index, 'duplicate'); },
        "blur": function (event) { return _vm.blur(index, 'duplicate'); }
      }
    })]), _vm._v(_vm._s()), _c('div', {
      staticClass: "col action remove",
      attrs: {
        "title": "Click to remove this row (Ctrl + Del)"
      }
    }, [_c('input', {
      staticClass: "action remove",
      attrs: {
        "type": "button",
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.remove(index)
        },
        "focus": function (event) { return _vm.focus(index, 'remove'); },
        "blur": function (event) { return _vm.blur(index, 'remove'); }
      }
    })])], 2)
  }))]), _vm._v(" "), _c('div', [(_vm.manyItems && _vm.limited) ? _c('a', {
    staticClass: "table-action",
    attrs: {
      "href": "#",
      "title": ("show all " + (_vm.items.length) + " items")
    },
    on: {
      "click": _vm.toggleLimit
    }
  }, [_vm._v("\n      show all (" + _vm._s(_vm.items.length) + ")\n    ")]) : _vm._e(), _vm._v(" "), (_vm.manyItems && !_vm.limited) ? _c('a', {
    staticClass: "table-action",
    attrs: {
      "href": "#",
      "title": ("show only the first " + _vm.ROW_LIMIT + " items")
    },
    on: {
      "click": _vm.toggleLimit
    }
  }, [_vm._v("\n      show only the first " + _vm._s(_vm.ROW_LIMIT) + " items\n    ")]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0) ? _c('a', {
    staticClass: "table-action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.removeAll
    }
  }, [_vm._v("\n      clear all\n    ")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col drag-handle",
    attrs: {
      "title": "Drag this row up or down to reorder (Ctrl + Arrow up/down)"
    }
  }, [_c('div', {
    staticClass: "drag-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ed2262f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimeTable.vue
// module id = 326
// module chunks = 0